import { useState, useEffect } from 'react'

// how long "Sent!" stays up after a successful resend, independent of the
// (usually longer) cooldown before another resend is allowed
const SENT_MESSAGE_DURATION_SEC = 5

// The resend control state shared by the sign-in OTP modal and the email
// verification code entry: after a resend, "Sent!" shows for
// SENT_MESSAGE_DURATION_SEC, then the remaining cooldown counts down until
// resend is available again. initialCooldown seeds the countdown on mount
// (without "Sent!", since the user didn't click Resend for that send).
export default function useResendCooldown(initialCooldown = 0) {
  const [resendCooldown, setResendCooldown] = useState(initialCooldown)
  const [sentMessageVisible, setSentMessageVisible] = useState(false)

  useEffect(() => {
    if (resendCooldown <= 0) return undefined
    const timer = setTimeout(() => setResendCooldown((c) => c - 1), 1000)
    return () => clearTimeout(timer)
  }, [resendCooldown])

  useEffect(() => {
    if (!sentMessageVisible) return undefined
    const timer = setTimeout(() => setSentMessageVisible(false), SENT_MESSAGE_DURATION_SEC * 1000)
    return () => clearTimeout(timer)
  }, [sentMessageVisible])

  return {
    resendCooldown,
    sentMessageVisible,
    // call once a resend succeeds
    startCooldown: (seconds) => {
      setSentMessageVisible(true)
      setResendCooldown(seconds)
    },
    // call when a resend starts, so the control shows its loading state
    clearCooldown: () => setResendCooldown(0),
  }
}
